import { useState } from 'react';
import business from '../../services/business.js';
import Modal from '../Modal.js';
import Loading from '../Loading.js';

export default function ModalReenvioComunicado({ hideModal, show, avancarEtapa, processo, etapa }) {

    const [salvandoDados, setSalvandoDados] = useState(false);

    const salvar = async (e) => {
        avancarEtapa();
        hideModal(e);
    }

    const handleClose = async (e) => {

        const body = document.body;

        try {
            const idProcesso = processo;
            const idEtapa = etapa;
            const idStatus = 14;

            if (!idProcesso || !idEtapa || !idStatus) {
                alert.warn('Faltam informações para realizar a ação.');
                return;
            }

            setSalvandoDados(true);
            const resp = await business.putEtapaStatus(idProcesso, idEtapa, idStatus);

            if (resp?.status === 200 || resp?.response || resp === true) {

                body.classList.remove('overflow-hidden');
                hideModal(e);
                window.location.reload();

            } else {
                alert.error('Não foi possível salvar as alterações.');
            }
        } catch (error) {
            console.error("Erro ao salvar etapa/status:", error);
            alert.error("Não foi possível salvar as alterações. Tente novamente.");
        } finally {
            setSalvandoDados(false);
        }
    };

    return (
        <Modal show={show} handleClose={handleClose} style={{ maxWidth: '1000px', maxHeight: '600px' }} modalClass="modal-cad-usuario">
            <div className="flex">
                <div className="form w-100">
                    <div className={`form-container grid`}>
                        <div className="span-3 mt-30">
                            <div className="fn-16 linha flex jc-sb">
                                <p>Essa comunicação já foi enviada, deseja enviar novamente?</p>
                            </div>
                        </div>
                    </div>
                    <div className="form-rodape mt-30 ">
                        <button className="btn btn-outline-primary f700-16" onClick={handleClose} disabled={salvandoDados}>
                            {salvandoDados ? <Loading /> : 'Não reenviar'}
                        </button>
                        <button className="btn btn-primary f700-16 mr-40" onClick={salvar}  >
                            Reenviar
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}